"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const useAppStateUpdateControlById_1 = __importDefault(require("../../../hooks/useAppStateUpdateControlById"));
const useAppGetColorFromSpecification_1 = __importDefault(require("../../../hooks/useAppGetColorFromSpecification"));
const CheckboxRender = ({ checkbox, }) => {
    var _a;
    const { Render, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const { onChange } = (0, useControlEvents_1.default)(checkbox);
    const updateControlById = (0, useAppStateUpdateControlById_1.default)();
    const onClick = (0, react_1.useCallback)(() => {
        const newValue = !!checkbox.value;
        updateControlById({
            control: checkbox,
            dataToUpdate: {
                value: !newValue,
            },
        });
        if (onChange) {
            onChange(!newValue);
        }
    }, [updateControlById, checkbox, onChange]);
    const getColor = (0, useAppGetColorFromSpecification_1.default)();
    return (react_1.default.createElement(Render.CheckBox, { isChecked: !!checkbox.value, onClick: onClick, checkColor: getColor((_a = checkbox.style) === null || _a === void 0 ? void 0 : _a.color) }));
};
exports.default = CheckboxRender;
